import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextareaComponent } from "../../templates/template-textarea/template-textarea.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-bs7",
  imports: [TemplateTextareaComponent],
  templateUrl: "./prefix-bs7.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-bs7.component.less",
})
export class PrefixBs7Component extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 500;
    this.characters = ALLOWED_CHARACTERS["bs7"];
  }
}
